import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "../ui/dialog";

export function PrivacyNotice({ triggerClassName = "", testid = "privacy-notice-button" }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <button type="button" data-testid={testid} className={triggerClassName}>
          Privacy notice
        </button>
      </DialogTrigger>
      <DialogContent data-testid="privacy-notice-modal" className="max-h-[85vh] max-w-2xl overflow-y-auto bg-ivory">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-ink">Privacy notice</DialogTitle>
          <DialogDescription className="text-sm text-ink/65">
            How your enquiry details are handled.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 text-sm leading-relaxed text-ink/75">
          <p>
            When you send an enquiry through this site, the details you provide (your name, email address,
            organisation and message) are used solely to respond to your enquiry and, if you choose to proceed, to
            shape a potential engagement.
          </p>
          <p>
            Your details are never sold, rented or shared with third parties for marketing. Enquiries are retained
            only for as long as needed to handle the conversation and any resulting engagement, after which they are
            deleted.
          </p>
          <p>
            Please avoid including sensitive personal data or confidential client information in your initial
            message. A brief outline is always enough to begin.
          </p>
          <p>
            You may ask at any time what information is held about you, request a copy, or ask for it to be corrected
            or deleted, by replying to any correspondence from this consultancy.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
